import { useEffect, useRef, useState } from 'react';
import './Navbar.css';
import { NavLink } from 'react-router-dom';
import ModalForm from '../Form/ModalForm.jsx';

export default function Navbar({ navItems }) {
  const [isHidden, setIsHidden] = useState(false);
  const lastScrollY = useRef(0);

  useEffect(() => {
    lastScrollY.current = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const delta = currentScrollY - lastScrollY.current;

      if (currentScrollY <= 24) {
        setIsHidden(false);
      } else if (delta > 6) {
        setIsHidden(true);
      } else if (delta < -6) {
        setIsHidden(false);
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const safeNavItems = Array.isArray(navItems)
    ? navItems.filter((item) => item?.label && item?.href)
    : [];

  return (
    <header className={`navbar${isHidden ? ' navbar--hidden' : ''}`}>
      <div className="navbar__inner">
        <NavLink className="navbar__brand" to="/">Нейросфера</NavLink>

        <nav className="navbar__nav" aria-label="Основная навигация">
          {safeNavItems.map((item) => (
            <NavLink
              key={item.label}
              className={({ isActive }) => `navbar__link${isActive ? ' current' : ''}`}
              to={item.href}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <ModalForm
          triggerText="Бета-тест"
          requestType="Запись на бета-тест"
          messagePrefix="Заявка на участие в бета-тестировании сайта Нейросфера."
          submitText="Записаться"
          successText="Заявка отправлена"
          triggerClassName="navbar__beta"
        />
      </div>
    </header>
  );
}
